import { render, staticRenderFns } from "./JournalEntryForm.vue?vue&type=template&id=8c2bd7e0"
import script from "./JournalEntryForm.vue?vue&type=script&lang=js"
export * from "./JournalEntryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports